import routerConfigList from './controller'
// import routerConfigListHard from './controller_hard'

import Vue from 'vue'
import Router from 'vue-router'

function getRouteResolve(lists, path = '') {
  // 系统维护期间,设置路由只能进一个页面

  // if (isDuringDate('2022-08-03 20:00:00', '2022-08-03 04:00:00')) {
  //   const resolve = (resolve) => require(['../containers/maintain/index'], resolve)
  //   return Object.keys(lists).map(list => {
  //     let meta = lists[list].meta
  //     // meta.shouldToAuthorizeUrl = false
  //     if (!lists[list].children) {
  //       return {
  //         path: path ? (list ? `/${path}/${list}` : `/${path}`) : `/${list}`,
  //         meta: meta,
  //         component: resolve
  //       }
  //     } else {
  //       return {
  //         path: `/${list}`,
  //         meta: meta,
  //         component: resolve,
  //         children: getRouteResolve(lists[list].children, list)
  //       }
  //     }
  //   })
  // }

  return Object.keys(lists).map(list => {
    if (!lists[list].children) {
      const selfPath = path ? (list ? `/${path}/${list}` : `/${path}`) : `/${list}`
      return {
        path: selfPath,
        meta: lists[list].meta,
        component: lists[list].resolve
      }
    } else {
      return {
        path: `/${list}`,
        meta: lists[list].meta,
        component: lists[list].resolve,
        children: getRouteResolve(lists[list].children, list)
      }
    }
  })
}

function configRouter(routes) {
  routes.forEach(route => {
    if (route.children && route.children.length) {
      configRouter(route.children)
    } else {
      // console.log('route.path before', route.path, route)
      if (route.path === '') {
        route.path = ':id'
      } else {
        route.path = `${route.path}/:id`
      }
      // console.log('route.path after', route.path)
    }
  })
}
Vue.use(Router)
let routerList = {
  mode: 'hash',
  routes: []
}
routerList.routes = getRouteResolve(routerConfigList)
configRouter(routerList.routes)
console.log(routerList)
export default new Router(routerList)



// WEBPACK FOOTER //
// ./src/router/index.js